<template>
  <div>
    <div class="bread-crumbs-box">
      <Breadcrumb separator="»" class="bread-crumbs container">
        <Breadcrumb-item class="breadcrumb-item" to="/">首页</Breadcrumb-item>
        <Breadcrumb-item v-if="parentId == 0" class="breadcrumb-item" to="/news"
          >新闻资讯</Breadcrumb-item
        >
        <Breadcrumb-item
          v-else
          class="breadcrumb-item"
          :to="'/news/' + parentId"
          >{{ parentCatalogName }}</Breadcrumb-item
        >
        <Breadcrumb-item class="breadcrumb-item-last">{{
          currentCatalog.name
        }}</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="container clearfix container">
      <div class="fl article-main">
        <div class="article-category">
          <a
            class="ac-btn btn-default btn-size"
            v-for="(item, index) in newsCatalogList"
            :key="index"
            :class="{ secondary: item.id == currentCatalog.id }"
            href="javascript:;"
            @click="changeCatalog(item)"
            >{{ item.name }}</a
          >
        </div>
        <div class="product-not-data" v-show="newsList.length == 0">
          <Icon
            type="md-warning"
            style="margin-right: 6px"
          />抱歉，没有找到相关的数据！
        </div>
        <ul class="article-main-list">
          <li class="clearfix" v-for="(item, index) in newsList" :key="index">
            <router-link :to="{ name: 'NewsDetail', params: { id: item.id } }">
              <img
                v-if="item.imageurl"
                :alt="item.title"
                :src="concatImageUrl(item.imageurl, 245, 180)"
              />
              <img
                v-else
                :alt="item.title"
                src="../../assets/images/v3/news-default.png"
              />
            </router-link>
            <h2>
              <router-link
                :to="{ name: 'NewsDetail', params: { id: item.id } }"
                >{{ item.title }}</router-link
              >
            </h2>
            <p>{{ item.summary }}</p>
            <span class="aml-time">
              <Icon type="md-stopwatch" size="18" />
              {{ item.createdate }}
            </span>
          </li>
        </ul>
      </div>
      <div class="page" v-show="totalCount > pageSize">
        <Page
          :total="totalCount"
          :current="pageIndex"
          :page-size="pageSize"
          @on-change="changePage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { article } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      parentId: 0,
      parentCatalogName: "",
      newsCatalogList: [],
      currentCatalog: {},
      newsList: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
    };
  },
  watch: {
    $route(to, from) {
      if (to.params.id !== from.params.id) {
        this.parentId = to.params.id;
        this.pageIndex = 1;
        this.getCatalogList();
      }
    },
  },
  mounted() {
    var isSuccess = this.initParams();
    if (!isSuccess) {
      this.$Message.error("参数初始化无效，请正确操作");
      return;
    }
    this.getCatalogList();
  },
  methods: {
    initParams() {
      this.parentId = this.$route.params.id;
      if (!this.parentId) {
        this.parentId = 0;
      }
      if (this.parentId == 0 && this.siteConfig.agencyId != 0) {
        return false;
      }
      return true;
    },
    getCatalogList() {
      article
        .getCatalogList(this.siteConfig.agencyId, this.parentId)
        .then((res) => {
          //console.log("catalog", res);
          if (res.status === 1) {
            this.parentCatalogName = res.data.parentName;
            this.newsCatalogList = res.data.list;
            if (this.newsCatalogList.length > 0) {
              if (this.parentId == res.data.parentId) {
                this.currentCatalog = this.newsCatalogList[0];
              } else {
                this.currentCatalog = this.newsCatalogList.filter(
                  (item) => item.id == this.parentId
                )[0];
              }
              this.parentId = res.data.parentId;
              //this.currentCatalog = this.newsCatalogList[0];
              this.setMetaData(this.currentCatalog.name);
              this.getArticleList();
            }
          }
        });
    },
    getArticleList() {
      article
        .getArticleList(this.currentCatalog.id, this.pageIndex, this.pageSize)
        .then((res) => {
          //console.log(res);
          if (res.status === 1) {
            this.totalCount = res.data.total;
            this.newsList = res.data.list;
          }
        });
    },
    changeCatalog(item) {
      this.currentCatalog = item;
      this.setMetaData(this.currentCatalog.name);
      this.pageIndex = 1;
      this.getArticleList();
    },
    changePage(page) {
      this.scrollTop();
      this.pageIndex = page;
      this.getArticleList();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";

.page {
  width: 1200px;
  text-align: center;
  margin: 20px auto 40px;
}

.bread-crumbs-box {
  background: #fff;
  margin-bottom: 32px;
  .bread-crumbs {
    height: 48px;
    line-height: 48px;
    background: #fff;
    .breadcrumb-item {
      color: #0e90d2;
      font-size: 15px;
    }
    .breadcrumb-item-last {
      color: #999;
      font-size: 15px;
    }
  }
}

.article-main {
  width: 1200px;
  padding: 25px;
  margin: 0 auto;
}
.article-main-list {
  li {
    border: 1px solid #d0d0d0;
    padding: 35px;
    margin-bottom: 30px;
    background-color: #fff;
    border-radius: 5px;
    img {
      float: left;
      width: 245px;
      height: 180px;
      margin-right: 50px;
      padding: 3px;
      border: 1px solid #d0d0d0;
    }
    h2 {
      font-size: 1.5em;
      margin: 0;
    }
    p {
      font-size: 16px;
      margin-top: 25px;
    }
    span {
      color: #acb5b8;
      font-size: 16px;
    }
    .aml-time {
      display: inline-block;
      margin-top: 1rem;
      margin-bottom: 1rem;
    }
  }
}

.article-category {
  margin-bottom: 2.4rem;
  a.secondary {
    color: #fff;
  }
  .btn-default {
    background-color: #acb5b8;
    border-color: #acb5b8;
    color: #fff;
  }
  .ac-btn {
    margin-right: 10px;
    margin-bottom: 10px;
    display: inline-block;
    margin-bottom: 0;
    padding: 0.5em 35px;
    vertical-align: middle;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.2;
    text-align: center;
    white-space: nowrap;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 0;
    cursor: pointer;
    outline: 0;
    -webkit-appearance: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transition: background-color 0.3s ease-out,
      border-color 0.3s ease-out;
    transition: background-color 0.3s ease-out, border-color 0.3s ease-out;
    margin-bottom: 1rem;
  }

  .btn-size {
    border-radius: 2px;
    font-size: 1.8rem;
  }
  .secondary {
    color: #fff;
    background-color: #3bb4f2;
    border-color: #3bb4f2;
  }
}

.product-not-data {
  text-align: center;
  font-size: 2.2rem;
  line-height: 1;
  color: orange;
  padding: 30px 0;
  i {
    font-size: 2.4rem;
  }
}
.product-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  li {
    padding: 0 0.5rem 1rem 0.5rem;
    flex: 0 0 20%;
    position: relative;
    .can-integral {
      position: absolute;
      left: 16px;
      top: 11px;
      width: 80px;
      height: 20px;
      background: url(../../assets/images/integral.png) no-repeat;
      z-index: 3;
    }
    .product-item {
      display: block;
      position: relative;
      background: #fff;
      border-radius: 5px;
      border: 1px solid transparent;
      padding: 10px;
      &:hover {
        border-color: #0195d3;
      }
      .product-item-image {
        width: 100%;
        height: 110px;
      }
      .product-item-type {
        color: #8e8e8e;
        font-size: 1.2rem;
      }
      .product-item-title {
        font-size: 1.6rem;
        color: #333;
        font-weight: normal;
      }
      .product-item-price {
        float: right;
        font-size: 1.6rem;
        font-weight: bold;
        color: #333;
        s {
          margin-left: 8px;
          color: #808080;
          font-size: 1.2rem;
        }
      }
    }
  }
}
.product-page {
  text-align: center;
  padding: 15px 0 20px 0;
}
</style>